import { isCurrencyAmount, parseCurrencyAmount } from '@/lib/format';

const isTextCell = (raw: string | undefined) => {
  const value = raw?.trim() ?? '';
  return value !== '' && !isCurrencyAmount(value);
};

/**
 * Bedrag van één datarij in een investeringstabel, gelezen uit de celteksten.
 *
 * Volgt dezelfde regels als de opslag (`tiptapDocToBlocks`): een bedragcel met
 * tekst die geen bedrag is ("€ 500 - € 2.000 per 4 weken", "op aanvraag") maakt
 * er een tekstregel zonder bedrag van. Zo telt de editor en de PDF hetzelfde op
 * als de webweergave en `{{quote.total}}`, in plaats van het eerste getal uit
 * die tekst.
 */
export function investmentRowAmount(cells: string[], isHourly: boolean): number {
  if (isHourly && cells.length >= 4) {
    if (isTextCell(cells[1]) || isTextCell(cells[3])) return 0;
    return parseCurrencyAmount(cells[1]) * parseCurrencyAmount(cells[2]);
  }
  if (cells.length >= 2) {
    const amount = cells[cells.length - 1];
    return isTextCell(amount) ? 0 : parseCurrencyAmount(amount);
  }
  return 0;
}
